const SET_USER = 'SET_USER';
const SET_EXPORTS = 'SET_EXPORTS';
const SET_LOADING = 'SET_LOADING';
const SET_CREDITS = 'SET_CREDITS';
const SET_SETTINGS = 'SET_SETTINGS';
const RESET_USER_INFO = 'RESET_USER_INFO';
const APPEND_EXPORTS = 'APPEND_EXPORTS';
const REMOVE_EXPORT = 'REMOVE_EXPORT';

export default {
    SET_USER,
    SET_EXPORTS,
    SET_LOADING,
    SET_CREDITS,
    SET_SETTINGS,
    RESET_USER_INFO,
    APPEND_EXPORTS,
    REMOVE_EXPORT
};
